import React from "react";

export const WhoCanTakeThisCourse = () => {
  return (
    <div className="who-can-take-this-course-section">
      <div className="who-can-take-this-course-header">
        <h2>Who Can Take This Course?</h2>
        <p>
          This training is open to anyone who wants to make a difference by
          truly listening:
        </p>
      </div>

      <div className="container">
        <div className="who-can-take-this-course-grid">
          <div className="who-can-take-this-course-card price-card">
            <p className="price-title">Course Price</p>
            <p className="price-value">₹2,999/-</p>
            <p className="price-desc">
              Call or WhatsApp <br /> +91-6366636157 <br /> to
              get started.
            </p>
            <p className="price-desc">Email : connect@listenaura.com</p>
          </div>

          <div className="who-can-take-this-course-card audience-card">
            <div>
              <p className="audience-heading">Counselors & Therapists</p>
              <p className="audience-desc">
                Deepen your empathetic listening practice
              </p>
            </div>
            <div>
              <p className="audience-heading">Social Workers</p>
              <p className="audience-desc">
                Build deeper, trust-based connections
              </p>
            </div>
            <div>
              <p className="audience-heading">Students</p>
              <p className="audience-desc">
                Learn life-changing skills for personal and career growth
              </p>
            </div>
          </div>

          <div className="who-can-take-this-course-card audience-card">
            <div>
              <p className="audience-heading">Teachers & Educators</p>
              <p className="audience-desc">
                Support students emotionally, beyond the classroom
              </p>
            </div>
            <div>
              <p className="audience-heading">Healthcare Workers</p>
              <p className="audience-desc">
                Listen with care, heal with empathy
              </p>
            </div>
            <div>
              <p className="audience-heading">People with Lived Experience</p>
              <p className="audience-desc">
                Turn your journey into strength for others
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
